import { H1, H2, P } from "design_lib";
export default function CompeteWin() {
  return (
    <div>
      <P>
        Success comes from choosing the right battlefield. Compete where you can leverage your
        strengths to create the most value. Identify the areas where your company has a competitive
        advantage, whether that’s superior technology, cost structure, customer insights, or
        distribution channels. Attempting to compete in markets or segments where you’re outmatched
        can quickly deplete resources and reduce profitability. By focusing on where you can win,
        you not only maximize returns but also build the foundation for long-term success. Strategic
        focus helps you stay nimble, resilient, and capable of adapting as competitive forces and
        market dynamics evolve.
      </P>
      <P className="text-center">
        <i>
          “Strategy is about making choices, trade-offs; it’s about deliberately choosing to be
          different.” – Michael E. Porter
        </i>
      </P>
      <H1>Examples:</H1>
      <H2>Netflix: Focusing on Streaming</H2>
      <P>
        Netflix’s decision to pivot from DVD rentals to streaming was a clear example of competing
        where it could win. The company realized that its strength was in data-driven
        personalization and content delivery, not in managing a massive physical inventory. By
        focusing on its core strengths in streaming and content production, Netflix dominated the
        entertainment industry, investing heavily in original content to set itself apart from
        traditional cable providers and other streaming services.
      </P>
      <H2>IKEA: Competitive Advantage in Cost Structure and Distribution</H2>
      <P>
        IKEA has mastered the art of low-cost, high-volume production in the furniture industry. By
        adopting a cost structure based on flat-pack designs and self-assembly products, IKEA has
        dramatically reduced its supply chain and manufacturing costs, passing the savings onto
        customers. Their distribution channels—a network of large, strategically placed stores
        around the world—coupled with a strong e-commerce platform, ensures accessibility and
        convenience for customers. The company’s cost leadership strategy and innovative
        distribution system allow it to remain a global leader in affordable home furnishings.
      </P>
      <H2>Spotify: Niche Focus in Music Streaming</H2>
      <P>
        Spotify carved out a competitive advantage by focusing specifically on music streaming
        rather than branching into other media types. By refining its algorithms and user
        experience, Spotify became the leader in personalized music discovery and curation. This
        focus on providing the best music-streaming experience allowed it to outmaneuver competitors
        like Apple Music and Pandora, who spread their efforts across various forms of
        entertainment.
      </P>
    </div>
  );
}
